module.exports = __webpack_public_path__ + "static/media/desktop-icons-buttons-pagination-left-arrow-disabled.8a102d27.svg";